module.exports = __webpack_public_path__ + "media/images/flags/4x3/dza-8ec59ccba0161b6d13578483388a4de4.svg";